export default {
  colorItem: {
    single: 'Solid',
    gradient: 'Gradient',
  },
  alignment: {
    ar: 'Arabic does not apply to Evenly Align Text',
    my: 'Burmese does not apply to Evenly Align Text',
  },
  textNode: {
    title: 'Text alignment',
  },
  textStyleShadow: {
    shadowBlur: 'Blur',
    title: 'Shadow',
  },
  textStyleSize: {
    fontSize: 'Font size',
    letterSpacing: 'Kerning',
    lineHeight: 'Line Height',
    bold: 'Bold',
    italic: 'Italic',
    underline: 'Underscore',
    strikethrough: 'Strikethrough',
  },
  textStyleStroke: {
    title: 'Stroke',
  },
  textStyle: {
    applyToOtherLanguage: 'Apply to other languages',
    languageMessage: [
      'No other languages',
      'Apply style to other languages successfully',
    ],
  },
}
